import { EQuestionActionsTypes, useFormContext } from '@cian/frontend-request-form-widget';
import { Button, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useResponsiveButtonSize } from '../../utils/hooks';
import { getActionButton } from '../../utils/getActionButton';
import { jsx as _jsx } from "react/jsx-runtime";
export var ButtonSubmitContainer = function ButtonSubmitContainer(_ref) {
  var question = _ref.question,
    _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? 'fill_primary' : _ref$theme;
  var deviceType = useDeviceType();
  var size = useResponsiveButtonSize();
  var _useFormContext = useFormContext(),
    submitForm = _useFormContext.submitForm,
    isSubmitting = _useFormContext.isSubmitting;
  var isPhone = deviceType === 'phone';
  var submitQuestionAction = getActionButton(question.actions, EQuestionActionsTypes.NextQ);
  if (!submitQuestionAction) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    type: "button",
    fullWidth: isPhone,
    theme: theme,
    size: size,
    loading: isSubmitting,
    disabled: isSubmitting,
    onClick: submitForm,
    children: submitQuestionAction.text
  });
};